import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './News.css';
import { Link, NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import {
  faPhone,
  faHome,
  faLock,
  faFileSignature,
  faFileContract,
  faExclamationTriangle,
  faArrowRight,
} from '@fortawesome/free-solid-svg-icons';
import {
  faXTwitter,
  faFacebook,
  faLinkedin,
  faInstagram,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import CONFIG from "./config";


axios.get(`${CONFIG.API_BASE_URL}/enquiries`)
  .then((res) => {
    console.log(res.data);
  })
  .catch((err) => {
    console.error(err);
  });


const navItems = [
  { title: 'आम्ही कोण आहोत?', path: '/leadership' },
  { title: 'बातम्या आणि ब्लॉग', path: '/news' },
  { title: 'संपर्क करा', path: '/contact' },
];

const PrivacyPolicy = () => {
  const [packagesByYear, setPackagesByYear] = useState({});
  const [yearsWithData, setYearsWithData] = useState([]);
  const [expandedYears, setExpandedYears] = useState({});
  const [loading, setLoading] = useState(true);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedCategoryByYear, setSelectedCategoryByYear] = useState({});
  const [latestNews, setLatestNews] = useState([]);

  const fetchAllData = async () => {
    try {
      const response = await axios.get(`${CONFIG.API_BASE_URL}/api/newsblogs`);
      if (response.status === 200 && response.data.status === 'success') {
        const uniqueCategories = [
          ...new Set(
            response.data.packages
              .map((pkg) => pkg.categoryid)
              .filter(Boolean)
          ),
        ];
        setCategories(uniqueCategories);

        const sortedPackages = response.data.packages.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );

        setLatestNews(sortedPackages.slice(0, 2));

        const grouped = {};
        sortedPackages.forEach((pkg) => {
          const pkgYear = new Date(pkg.date).getFullYear();
          if (!grouped[pkgYear]) grouped[pkgYear] = [];
          grouped[pkgYear].push(pkg);
        });
        setPackagesByYear(grouped);

        const years = [...new Set(sortedPackages.map((pkg) => new Date(pkg.date).getFullYear()))]
          .sort((a, b) => b - a);
        setYearsWithData(years);

        if (years.length) setExpandedYears({ [years[0]]: true });
      }
    } catch (err) {
      console.error('Error fetching data:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  const truncateText = (text, maxLength = 2000) => {
    if (!text) return '';
    return text.length <= maxLength ? text : text.slice(0, maxLength) + '...';
  };

  const toggleYearExpand = (year) => {
    setExpandedYears((prev) => ({ ...prev, [year]: !prev[year] }));
  };

  if (loading) {
    return (
      <div className="loader-container">
        <div className="spinner"></div>
        <p>लोड होत आहे... कृपया थांबा</p>
      </div>
    );
  }

  const NewsCard = ({ pkg }) => {
  const imageUrl = pkg.pakageimage1
  ? `${CONFIG.API_BASE_URL}/public/uploads/packages/${pkg.pakageimage1}`
  : '/not_found.png';

  return (
      <div className="news-card">
        <div className="media-section">
          <img
            src={imageUrl}
            alt={pkg.turename || 'Not Found'}
            loading="lazy"
            onError={(e) => (e.target.src = '/not_found.png')}
          />
        </div>
        <div className="text-section">
          <h4>{pkg.turename}</h4>
          <p
            className="read-more-text"
            dangerouslySetInnerHTML={{
              __html: truncateText(pkg.filldesc, 300),
            }}
          ></p>
          <div className="read-more-wrapper">
            <Link to={`/new/${pkg.id}`} className="read-more-btn">
              Read More <FontAwesomeIcon icon={faArrowRight} />
            </Link>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {/* Header */}
      <header className="header">
        <div className="nav-container">
          <div className="logo">
            <Link to="/">
  <img src="https://lokadhikar.in/web.png" alt="PIR Logo" />
</Link>

          </div>
          <nav className="nav-links">
            {navItems.map((item, index) => (
              <div key={index} className="nav-item">
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    isActive ? 'nav-button active' : 'nav-button'
                  }
                >
                  {item.title}
                </NavLink>
              </div>
            ))}
          </nav>
          <div className="search-language" style={{ position: 'relative' }}>
            <div
              style={{
                position: 'absolute',
                top: '-19px',
                left: '16px',
                fontSize: '22px',
                color: '#FF6F00',
                fontFamily: 'Mukta, sans-serif',
                whiteSpace: 'nowrap',
                zIndex: 10,
                pointerEvents: 'none',
              }}
            >
              <span className="lokadhikar-title">महाराष्ट्र लोकाधिकार समिती</span>
            </div>
            <div className="pir-search-wrapper"></div>
          </div>
          <button
            className="mobile-toggle"
            onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
          >
            ☰
          </button>
        </div>
        {isMobileMenuOpen && (
          <div className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            {navItems.map((item, index) => (
              <Link
                key={index}
                className="mobile-link"
                to={item.path}
                onClick={() => setMobileMenuOpen(false)}
              >
                {item.title}
              </Link>
            ))}
          </div>
        )}
      </header>

      {/* Latest News & Blogs */}
      {latestNews.length > 0 && (
        <div className="latest-news-wrapper">
          <h1 style={{ marginBottom: '20px', color: '#FF6F00', textAlign: 'center' }}>
            Latest Blogs, News and Announcements
          </h1>
          <div className="news-grid">
            {latestNews.map((pkg) => (
              <NewsCard key={pkg.id} pkg={pkg} />
            ))}
          </div>
        </div>
      )}

      {/* Timeline Section */}
      <div className="timeline-wrapper">
        <h1 style={{ marginBottom: '20px', color: '#FF6F00', textAlign: 'center' }}>
          Latest News & Blogs
        </h1>
        {yearsWithData.map((year) => {
          const packages = packagesByYear[year] || [];
          const isExpanded = expandedYears[year];

          return (
            <div key={year} className="timeline-block">
              <div className="timeline-card">
                <button className="expand-btn" onClick={() => toggleYearExpand(year)}>
                  {isExpanded ? '−' : '+'}
                </button>
                <div className="year-dropdown-wrapper">
                  <div className="year-label">{year}</div>
                  <div className="filter-wrapper">
                    <label htmlFor={`categoryFilter-${year}`}>
  <FontAwesomeIcon icon={faFilter} style={{ marginRight: '5px' }} />
  Media Type:
</label>
                    <select
                      id={`categoryFilter-${year}`}
                      value={selectedCategoryByYear[year] || 'All'}
                      onChange={(e) =>
                        setSelectedCategoryByYear(prev => ({ ...prev, [year]: e.target.value }))
                      }
                      className="form-control"
                      required
                      tabIndex={2}
                    >
                      <option value="All">All</option>
                      {categories.map((cat, index) => (
                        <option key={index} value={cat}>{cat}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              {isExpanded && (
                <div className="news-grid">
                  {packages
                    .filter(
                      (pkg) =>
                        (selectedCategoryByYear[year] || 'All') === 'All' ||
                        pkg.categoryid === (selectedCategoryByYear[year] || 'All')
                    )
                    .map((pkg) => (
                      <NewsCard key={pkg.id} pkg={pkg} />
                    ))}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Footer */}
      <footer className="pir-footer">
        <div className="footer-container">
          <div className="footer-left">
            <img src="https://lokadhikar.in/web.png" alt="Logo" className="footer-logo-vertical" />
          </div>
          <div className="footer-center">
            <div className="footer-links-columns">
              <ul className="footer-links">
                <li>
                  <a href="/privacypolicy">
                    <FontAwesomeIcon icon={faLock} /> गोपनीयता धोरण <span>(Privacy Policy)</span>
                  </a>
                </li>
                <li>
                  <a href="/signuppolicy">
                    <FontAwesomeIcon icon={faFileSignature} /> नोंदणी धोरण <span>(Signup Policy)</span>
                  </a>
                </li>
              </ul>
              <ul className="footer-links">
                <li>
                  <a href="/termsuse">
                    <FontAwesomeIcon icon={faFileContract} /> वापर अटी <span>(Terms of Use)</span>
                  </a>
                </li>
                <li>
                  <a href="/disclaimer">
                    <FontAwesomeIcon icon={faExclamationTriangle} /> अस्वीकृती <span>(Disclaimer)</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-right">
                    <div className="footer-social">
                      <a href="https://x.com/Lokadhikar2005?t=n-S1KS-Ao-aj7fmOe-QRxw&s=09"  target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faXTwitter} /></a>
                      <a href="https://www.facebook.com/groups/2151387758675095/?ref=share&mibextid=NSMWBT" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faFacebook} /></a>
                     <a href="https://www.linkedin.com/in/lokadhikar-samiti-0537a937a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faLinkedin} /></a>
                      <a href="https://www.instagram.com/lokadhikar.in?igsh=ZXN0bHpiYm5nMjg=" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faInstagram} /></a>
                      <a href="https://youtube.com/@lokadhikar-2005?si=cuc0vPRI6NLxhaQs" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faYoutube} /></a>
                    </div>
                  </div>
        </div>
        <div className="footer-bottom">
          <p className="marathi-text">
            © २०२५ महाराष्ट्र लोकाधिकार समिती – <span className="blue-tex">सर्व हक्क राखीव</span>
          </p>
        </div>
      </footer>

      <ul className="right-side-icons">
        <li>
          <a href="/" className="icon-link pulse-glow" title="Home">
            <FontAwesomeIcon icon={faHome} />
          </a>
        </li>
        <li>
          <a href="tel:+917887779899" className="icon pulse-glow" title="Call Us">
            <FontAwesomeIcon icon={faPhone} />
          </a>
        </li>
      </ul>
    </>
  );
};

export default PrivacyPolicy;
